import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import * as R from 'Router/routes';
import { useRiskEvaluationSolvencyQuery } from 'hooks/webapi';
import { Button, HelpInfo, Typography } from '../../../components';
import styles from './OfflinePSD2Error.module.scss';

export default function OfflinePSD2Error() {
  const { t } = useTranslation(['psd2_error', 'help_info']);
  const [isPending, setPending] = useState(false);
  const { refetch: refetchRiskEvaluationSolvency } =
    useRiskEvaluationSolvencyQuery(false);
  const navigate = useNavigate();

  const handleSolvencyCheck = async () => {
    try {
      setPending(true);
      const { data: solvencyRiskEvaluation } =
        await refetchRiskEvaluationSolvency();

      if (solvencyRiskEvaluation?.resolution === 'APPROVED') {
        navigate(R.APPROVED);
        return;
      }

      if (
        solvencyRiskEvaluation?.resolution === 'MANUAL' &&
        ['ASK_FOR_DOCUMENTS', 'Insufficient_PSD2_Income'].includes(
          solvencyRiskEvaluation.message,
        )
      ) {
        navigate(R.INCOME_PROOF);
        return;
      }

      throw new Error('ResulutionError: failed to meet condition');
    } catch (error) {
      // NOTE: For testing and logging purposes
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <div className={styles['box-wrapper']}>
        <Typography className={styles.title} kind="h1" size="l">
          {t('page_title')}
        </Typography>
        <Typography className={styles.description}>{t('info_text')}</Typography>
        <Button
          dataTest="psd2-error-continue-button"
          pending={isPending}
          onClick={handleSolvencyCheck}
          className={styles.button}
        >
          {t('continue_button')}
        </Button>
        <HelpInfo title={t('help_info:title')} text={t('help_info:text')} />
      </div>
    </>
  );
}
